// Projects data.
// Note: Here we are getting data from a js file, but in a different project I'll be fetching these projects from some srt of APIs.

const projects = [
	{
		id: 1,
		title: 'Ceramicas San Rafael',
		category: 'Pagina Web',
		img: require('@/assets/images/Ceramicas sanra.png'),
	},
	{
		id: 2,
		title: 'Frio Mundo',
		category: 'Pagina Web',
		img: require('@/assets/images/Frio mundo.png'),
	},
	{
		id: 3,
		title: 'La diamantina',
		category: 'Pagina Web',
		img: require('@/assets/images/Diamantina.png'),
	},
	{
		id: 4,
		title: 'NFTS',
		category: 'Blockchain',
		img: require('@/assets/images/nftssss.png'),
	},
	{
		id: 5,
		title: 'ChatBot-Wsp',
		category: 'ChatBots',
		img: require('@/assets/images/Chat Bot.png'),
	},
	{
		id: 6,
		title: 'Portafolio-React',
		category: 'Pagina Web',
		img: require('@/assets/images/Portafolio.png'),
	},
	{
		id: 6,
		title: 'Poaps Generator',
		category: 'Blockchain',
		img: require('@/assets/images/Poaps.png'),
	},
];

export default projects;
